import { jsonSchema } from "@redotech/redo-automations-model/graph/automation";
import { scenarioInputSchema } from "@redotech/redo-automations-runtime/testing/scenario";
import * as z from "zod";
import {
  definitionInputSchema,
  diagnosticSchema,
  stepRecordSchema,
} from "./common";

/**
 * Runs a definition against a scenario on the simulation host ("Test
 * automation"): nothing real is read or performed, except that Function steps
 * run their saved code in RedoJS.
 */
export const simulate = {
  name: "simulate" as const,
  input: z.object({
    definition: definitionInputSchema,
    scenario: scenarioInputSchema,
  }),
  output: z.discriminatedUnion("ok", [
    z.object({
      ok: z.literal(true),
      status: z.enum([
        "running",
        "completed",
        "failed",
        "rejected",
        "cancelled",
      ]),
      /** Node ids in execution order, including skipped ones. */
      path: z.array(z.string()),
      steps: z.array(stepRecordSchema),
      /** The effect the run is parked on when the scenario never answers it (e.g. an event that never arrives). */
      suspendedOn: z.string().nullable(),
      records: z.record(z.string(), z.record(z.string(), jsonSchema)),
      /** Lookups nothing answered; the run used each field's fallback. */
      unanswered: z.array(
        z.object({ resolver: z.string(), field: z.string() }),
      ),
      failure: z
        .object({ nodeId: z.string().nullable(), message: z.string() })
        .nullable(),
      rejection: z.string().nullable(),
      /** What each Function step's code logged, by step id. */
      logs: z.record(z.string(), z.string()),
    }),
    z.object({ ok: z.literal(false), diagnostics: z.array(diagnosticSchema) }),
  ]),
};
